import { Radio } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekRadio = styled(Radio)(({ theme }) => ({
    "&.MuiRadio-root": {
        color: theme.palette.grey[400],
    },
    "&.Mui-checked": {
        color: theme.palette.success.main,
    },
    "& .MuiSvgIcon-root": {
        borderRadius: "50%",
        padding: "2px",
        width: "12px",
        height: "12px",
        border: `0.5px solid ${theme.palette.grey[400]}`,
    },
    "&.Mui-checked .MuiSvgIcon-root": {
        borderColor: theme.palette.success.main,
        backgroundColor: theme.palette.success.light,
    },
}));

export { PeekRadio, PeekRadio as default };
